<template>
<div class="reportPage">
  <div class="report">
    <div class="reportImgWrapper">
      <img :src="picPath" class="reportPic"/>
    </div>
    <div class="buttonGroupWrapper" :style="{'--inputColor':terminalColor}">
        <div class="savebuttonGroup" :style="{'--inputColor':terminalColor}">
            <div @click="onceMoreAction" :style="{'--inputColor':terminalColor}"
             class='savereportButton buttonMargin'>再次查询</div>
            <div @click="getReport" v-show='getButtonShow&&getPicShow' 
            :style="{'--inputColor':terminalColor}"
            class='savereportButton'>领取企业报告</div>
        </div>
       </div>
       <div v-show="getReportShow">
          <SaveReportDialog  @dialogGoBack="saveReportDisapear" />
       </div>      
  </div>
  <div v-if='dialogShow'>
       <Dialog :type='getReportType'
               :errMsg='getReportRes'
               @dialogGoBack="dialogGoBack()"
               />
        </div>
        <SendMessage v-if="sendMessageShow" @dialogGoBack="sendMessageClose"/>
        <Waiting v-if="isWaitingShow"/>
</div>
</template>

<script>
import SaveReportDialog from '../../components/saveReport/saveReport.vue'
import Dialog from '../../components/dialog/dialog.vue'
import SendMessage from '../../components/sendMesssage/sendMessage.vue'
import Waiting from '../../components/waiting/waiting'
import shareImpl from '../../utils/wxApi'
import { getWebReportImageUrl ,synchronizedValReportInfo,sendSMSReportInfo} from '../../api/api'
export default {
  name: 'reportPage',
  components: {SaveReportDialog, Dialog, SendMessage, Waiting},
  data() {
    return {
      picPath: '',
      getReportShow: false,
      getReportRes: '请联系客服请联系客服请联系客服请联系客服请联系客服请联系客服',
      getReportType: 'warn',
      dialogShow: false,
      sendMessageShow: false,
      isWaitingShow: false,
      getButtonShow:true,
      getPicShow:false,
      canShare:'',
    }
  },
  async mounted() {
    // this.canShare='share'
    this.isWaitingShow=true
    const reportSn = this.$route.query.reportId
    // const linkNumber = this.$route.query.n||'';
    if(sessionStorage.getItem(reportSn)){
      this.getButtonShow = false
    }
    // console.log('this.$router', this.$route)
    const params = {reportSn}
    // console.log(111,typeof params.linkNumber)
    await getWebReportImageUrl(params).then((res)=>{
      if(res.code==="S01"){
         this.picPath = res.results.reportUrl
         this.canShare=res.results.enterpriseName+'估值报告'
         this.getPicShow = true
      }else{
      this.dialogShow = true
      this.getReportType = 'alert'
      this.getReportRes = res.message
      // this.picPath = 'https://fdfs.mogugu.com/group1/M00/03/10/rBPd8WJZAEKAMS6tAAxpGWgEY68212.png'
      }
    },()=>{})
    this.isWaitingShow=false
  },
  methods: {
    getReport() {
      this.getReportShow = true
      this.getReportRes = '请联系客服'
      this.getReportType = 'warn'
    },
    onceMoreAction() {
      console.log(this.$route.query)
      let queryParams = {};
              if(this.$route.query.n){
                queryParams.n = this.$route.query.n||''
              }
              if(this.$route.query.s){
                queryParams.s = this.$route.query.s||''
              }      
      this.$router.push({path:'/',query:queryParams});
      
      document.documentElement.scrollTop=0
    },
    dialogGoBack(e) {
      this.dialogShow = e
    },
      saveReportDisapear(a, b, c) {
      this.getReportShow = a
      let  snVal = this.$route.query.reportId
      let saveReport = JSON.parse(b)
      let params={reportSn:snVal}
      // localStorage.setItem('token',saveReport.accessToken)
      if(c==='error'){
        let aletMsg = JSON.parse(b)
        this.dialogShow = true
        this.getReportType = 'alert'
        this.getReportRes = aletMsg.message
      }
      if(localStorage.getItem('token')){
         synchronizedValReportInfo(params).then(
        (res)=>{
          if(res.code==='S01'){
            this.sendSMSReportInfoWrapper()
        }else{
          this.dialogShow = true
          this.getReportType = 'alert'
          this.getReportRes = res.message
        }
        },
        (err)=>{this.dialogShow = true
                this.getReportType = 'alert'
                this.getReportRes = err.message
                })
     }
    },
    sendSMSReportInfoWrapper(){
      const reportSn = this.$route.query.reportId.toString();
      const params = {reportSn:this.$route.query.reportId,
                      valuationId:0}
         sendSMSReportInfo(params).then((res)=>{
           if(res.code==='S01'){
             this.sendMessageShow = true;
              sessionStorage.setItem(reportSn,true)
              this.getButtonShow = false
           }else{
             this.dialogShow = true
             this.getReportType = 'alert'
             this.getReportRes = res.message
           }
         },(err)=>{
           this.dialogShow = true
           this.getReportType = 'alert'
           this.getReportRes = err.message
          //  console.log(666,err)
         })
    },
    sendMessageClose(a){
        this.sendMessageShow = a;
    }
  },
  watch: {
  canShare: function (val) {
    console.log('share',val)
       shareImpl({
               shareTitle: val,
               shareDesc: '30秒快速计算企业价值，别让投资人“低估”了你!',
               shareUrl: location.href,
               shareImg: 'https://s2.loli.net/2022/05/01/judNJWZIR3PqfwD.png'
                    })
    },
  },
  computed:{
    terminalColor(){
    return this.$store.state.admin.config.terminalColor;
    }
  }

}
</script>

<style lang ="less">
.reportPage{
 width:100%;
 height: 100vh;
 position:relative;
 overflow: auto;
.report{
  width:100%;
  height:100%;
  /* height:auto; */
  /* min-height:calc(100% - 2.08rem); */
}
.reportPic{
  width:100%;
  height:auto; 
  min-height:calc(100vh - 2.08rem);
}
.reportImgWrapper{
  min-height:calc(100% - 2.08rem);
   width:100%;
}
.savebuttonGroup{
  display: flex;
  justify-content: center;
  // background-color:#5883ff;
  background-color:var(--inputColor);
  padding: 0.6rem 0 0.6rem 0;
}
.buttonMargin{
  margin-right: 0.3rem;
}

.savereportButton{
  width:3.3rem;
  height:0.88rem;
  text-align: center;
  line-height: 0.88rem;
  font-weight: 100;
  border-radius: .1rem;
  border:0;
  font-size: 0.3em;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  // color: #5883ff;
  color:var(--inputColor);
  background-color:#fff;
}
.buttonGroupWrapper{
  overflow:hidden;
  // background-color:#5883ff;
  background-color:var(--inputColor);

}

}
</style>



// WEBPACK FOOTER //
// src/pages/reportPage/reportPage.vue